import { useMemo } from 'react'

/* Ein Feld, in das der Browser nichts hineinschreiben darf.

   Safari haelt jedes Textfeld fuer ein moegliches Namensfeld und bietet
   Kontakte aus dem Adressbuch an; dazu merkt es sich, was frueher in ein
   Feld gleichen Namens getippt wurde. In einer Mandantenliste ist beides
   Unsinn und verdeckt die Treffer. Drei Dinge halten es davon ab, und
   gebraucht werden alle drei:

   - type="search" — Suchfelder nimmt Safari von der Kontaktergaenzung
     aus. Lupe und Abbrechkreuz sind in grund.css abgeschaltet.
   - ein Feldname, den es so noch nie gab — die gespeicherte
     Formularhistorie haengt am Namen und findet damit nichts wieder.
     Deshalb darf im Namen auch nie "name" vorkommen.
   - autoComplete aus, dazu die Schalter fuer 1Password und LastPass. */
export function Filterfeld({
  wert,
  setzeWert,
  beschriftung,
  platzhalter = 'Filtern',
  className,
}: {
  wert: string
  setzeWert: (wert: string) => void
  beschriftung: string
  platzhalter?: string
  className?: string
}) {
  const feldname = useMemo(
    () => `filter-${Math.random().toString(36).slice(2, 10)}`,
    [],
  )

  return (
    <input
      type="search"
      className={className}
      name={feldname}
      placeholder={platzhalter}
      value={wert}
      onChange={(e) => setzeWert(e.target.value)}
      autoComplete="off"
      autoCorrect="off"
      autoCapitalize="off"
      spellCheck={false}
      data-1p-ignore
      data-lpignore="true"
      data-form-type="other"
      aria-label={beschriftung}
      aria-autocomplete="none"
    />
  )
}
